import BaseModelMap from "../../../src/models/BaseModelMap";
import TemplateGroup, { productTemplateCategories as categories, type ProductCategoryKey } from "../../../src/models/TemplateGroup";
export type C1_ProductCategoryKey = ProductCategoryKey;
import DeviceTemplate from "../../../src/models/DeviceTemplate";
import type { C1_ProductData } from "../types/C1_ModelTypes";

/** Presents persistent templates to the existing C1 product editor. */
export class C1_ProductCategory {
  constructor(
    private readonly products: C1_Products,
    private readonly key: C1_ProductCategoryKey,
  ) {}

  getSegmentGroup(segment: string): TemplateGroup | undefined {
    const definition = categories[this.key];
    const group = this.products.root.findFirst((item) => item.tag === definition.tag);
    if (this.key === "sensors" && segment === "general") return group;
    const segmentTag = definition.segments[segment]?.tag;
    return group?.templateGroups.findFirst((item) => item.tag === segmentTag);
  }

  getSegment(segment: string): DeviceTemplate[] {
    return this.getSegmentGroup(segment)?.templates.sortBySensytive("tagOrName") ?? [];
  }

  /** Imports a catalog selection as a normal ESTADA template, once per product variant. */
  async addProduct(segment: string, product: C1_ProductData): Promise<DeviceTemplate> {
    const group = this.getSegmentGroup(segment);
    if (!group) throw new Error("Die C1-Produktgruppe ist noch nicht angelegt.");
    if (product.genericParams) return DeviceTemplate.createGeneric(group, product.genericParams, product.orderNumber, product.genericProductType);
    const catalogId = product.catalogId || product.catalogItem?.CatalogId;
    if (!catalogId || !product.catalogItem) throw new Error("Für dieses Produkt fehlen die Katalogdaten.");
    const existing = group.templates.findFirst(
      (template) =>
        template.knxProductData.modelDataId === catalogId &&
        (template.orderInformation.articleNo || "") === (product.variantArticleNumber || ""),
    );
    if (existing) return existing;
    const template = await DeviceTemplate.createFromServerData(
      group,
      catalogId,
      product.catalogItem,
      product.variantArticleNumber,
    );
    if (product.variantArticleNumber) template.orderInformation.articleNo = product.variantArticleNumber;
    if (!template.orderInformation.imageLink && product.imageUrl)
      template.orderInformation.imageLink = product.imageUrl;
    return template;
  }
}

/** Provides the C1 editor with products stored exclusively in ESTADA template groups. */
export class C1_Products {
  readonly buttons = new C1_ProductCategory(this, "buttons");
  readonly actors = new C1_ProductCategory(this, "actors");
  readonly sensors = new C1_ProductCategory(this, "sensors");

  constructor(private readonly groups: BaseModelMap<TemplateGroup>) {}

  get root(): BaseModelMap<TemplateGroup> {
    return this.groups;
  }
}
